<template>
	<div class="col-12 pl-0 pr-0">
		<div class="col-12 pl-0 pr-0">
			<transition name="slide-fade">
				<div class="col-12 pl-4 pr-4 pt-4 pb-2 mt-3 bg-white cus-box-shadow rounded-cus d-flex flex-wrap" v-if="!mitraMLM.status || mitraMLM.is_active == '0'">
					<div class="col-lg-12 pl-0 pr-0">
						<div class="col-12 pl-0 pr-0 pb-1 font-size-13 font-weight-bold">
							Masukan Kode Mitra
						</div>
						<div class="col-12 pl-0 pr-0 pt-3 pb-1">
							<div class="pl-0 mt-auto mb-auto font-size-9">Kode Mitra</div>
							<div class="col-12 pl-0 pr-0 pt-1 pb-1">
								<span class="icon-mitra-code"><img src="/assets/transaction/gs-icon.svg"></span>
								<!-- <input v-model="mitra_code" placeholder="Contoh : GSXXXXXX " class="input-mitra-code form-control box-blue rounded-cus font-size-10 font-weight-bold text-uppercase" type="text" @keyup.enter = "checkMitra"> -->
								<v-select v-model="mitra_code" :options="memberHasTransaction" appendToBody placeholder="Contoh : GSXXXXXX" class="input-mitra-code box-blue rounded-cus font-size-10 font-weight-bold" label="member_text" taggable :create-option="el => ({ member_network_mid: el, member_name: '', member_text: el })" :reduce="el => `${el.member_network_mid}`" @input="checkMitra">
									<template v-slot:no-options>
										Belum ada mitra yang melakukan transaksi
									</template>
								</v-select>
							</div> 
							<AlertInput v-if="alert_mitra" :message="alert_mitra"/>
						</div>
						<!-- <div class="font-size-8 pt-1 color-orange">Contoh : GSXXXXXX</div> -->
						<div class="col-12 pl-0 pr-0 pb-2 text-center pt-2">
							<button class="col-6 col-md-3 btn btn-blue rounded-cus box-purple" @click="checkMitra">
								<div class="font-size-11 text-uppercase">Cek Mitra</div>
							</button>
						</div>
					</div>
				</div>
			</transition>
			<transition name="slide-fade">
				<div class="col-12 pl-4 pr-4 pt-4 pb-2 mt-3 bg-white cus-box-shadow rounded-cus d-flex flex-wrap" v-if="mitraMLM.status && mitraMLM.is_active == '1'">
					<div class="col-lg-12 pl-0 pr-0">
						<div class="col-12 pl-0 pr-0 pb-1 font-size-13 font-weight-bold">
							Data Mitra
						</div>
						<div class="col-12 pl-0 pr-0 pt-3 pb-1">
							<div class="pl-0 mt-auto mb-auto font-size-9">Kode Mitra</div>
							<div class="col-12 pl-0 pr-0 pt-1">
								<span class="icon-mitra-code"><img src="/assets/transaction/mb-icon.svg"></span>
								<input readonly class="input-mitra-code form-control box-blue rounded-cus font-size-10 font-weight-bold" type="text" :value="mitraMLM.network_mid.toUpperCase()">
							</div>
						</div>
						<div class="col-12 pl-0 pr-0 pt-3 pb-1">
							<div class="pl-0 mt-auto mb-auto font-size-9">Nama Mitra</div>
							<div class="col-12 pl-0 pr-0 pt-1">
								<span class="icon-mitra-code"><img src="/assets/transaction/user-solid.svg"></span>
								<input readonly class="input-mitra-code form-control box-blue rounded-cus font-size-10 font-weight-bold" type="text" :value="mitraMLM.name.toUpperCase()">
							</div>
						</div>
						<div class="col-12 pl-0 pr-0 pt-3 pb-1">
							<div class="pl-0 mt-auto mb-auto font-size-9">Kota Mitra</div>
							<div class="col-12 pl-0 pr-0 pt-1">
								<span class="icon-mitra-code"><i class="fas fa-map-marker-alt"></i></span>
								<input readonly class="input-mitra-code form-control box-blue rounded-cus font-size-10 font-weight-bold" type="text" :value="kotaprovinsi">
							</div>
						</div>
						<div class="col-12 pl-0 pr-0 pt-3 pb-2 d-flex justify-content-center">
							<button class="col-5 col-md-3 btn btn-outline-danger rounded-cus mr-4 mr-md-3" @click="resetmitraMLM">
								<div class="font-size-11 text-uppercase">kembali</div>
							</button>
							<button class="col-6 col-md-3 btn btn-blue rounded-cus box-purple" @click="lanjut">
								<div class="font-size-11 text-uppercase">selanjutnya</div>
							</button>
						</div>
					</div>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions} from 'vuex';
import AlertInput from '@/components/elements/alert/AlertInput.vue';
export default {
	components:{
		AlertInput
	},
	data() {
		return {
			mitra_code: '',
			alert_mitra: ''
		}
	},
	computed:{
		...mapState('commonList', ['mitraMLM']),
		...mapState('transactionList', ['memberHasTransaction']),

		kotaprovinsi(){
			let data = ''
			if (this.mitraMLM.city_name && this.mitraMLM.province_name) {
				data = this.mitraMLM.city_name +', '+ this.mitraMLM.province_name
			} else if (this.mitraMLM.city_name && !this.mitraMLM.province_name) {
				data = this.mitraMLM.city_name
			} else {
				data = '-'
			}
			return data;
		}
	},
	methods:{
		...mapActions('commonList', ['getmitraMLM']),
		...mapActions('cart', ['getregisterItem']),
		...mapMutations('cart', ['step_up',]),
		...mapMutations('commonList', ['resetmitraMLM']),
		...mapActions('transactionList', ['getMemberHasTransaction']),

		checkMitra() {
			this.alert_mitra = ''
			if (!this.mitra_code) {
				this.alert_mitra = 'Kode Mitra tidak boleh kosong'
			} else {
				this.getmitraMLM({
					member_network_mid: this.mitra_code
				}).then( () => {					
					if (!this.mitraMLM.status) {
						this.alert_mitra = 'Kode Mitra tidak ditemukan'
					} else if (this.mitraMLM.is_active == '0') {
						this.alert_mitra = 'ID tersebut sudah expired, dan tidak bisa digunakan'
					}
				})
			}
		},
		lanjut() {
			this.getregisterItem().then( () => {
				this.step_up()
			})
		}
	},
	created() {
		this.resetmitraMLM()
		this.getMemberHasTransaction()
	}
};
</script>